import { Action } from '@canvas/model/permissions';
import { appPermissions } from '@canvas/permissions/singleton';

import { Ability } from './abilities-types';

const canWrite = () => appPermissions.can(Action.write);

const canRead = () => appPermissions.can(Action.read);
const canOnlyRead = () =>
  appPermissions.can(Action.read) && appPermissions.cannot(Action.write);

const canAddComment = () => appPermissions.can(Action['add/comment']);
const canDeleteComment = () => appPermissions.can(Action['delete/comment']);

export const can = (ability: Ability) => {
  switch (ability) {
    case Ability.read: {
      return canRead();
    }
    case Ability.write: {
      return canWrite();
    }
    case Ability.readOnly: {
      return canOnlyRead();
    }
    case Ability.addComment: {
      return canAddComment();
    }
    case Ability.deleteComment: {
      return canDeleteComment();
    }
  }
};
